export const checkHorizontalOverflow = (container: HTMLElement) => {
  const scrollWidth = container.scrollWidth
  const clientWidth = container.clientWidth

  return {
    hasOverflow: scrollWidth > clientWidth,
    scrollWidth,
    clientWidth,
  }
}
